import { cloneDeep } from 'lodash';
import { DateTime } from 'luxon';
import { Claims } from 'models';
import { RecurrenceType } from 'models/recurrence';
import { nextAutomationDatetime } from 'models/recurrence/recurrence_helpers';
// import { FormSection } from 'types/form_interfaces';
import { excludeUndefinedValues } from 'utils/obj_utils_new';
import { WorkOrderStatus } from './work_order_enums';
import { WorkOrderTemplateNew, WOTFormData } from './work_order_interfaces';



// Strip out any values or checked states from custom form sections
export const cleanSections = (sections) =>
{
	console.log(sections);
	
	
	return sections.map(section =>
	{
		let cleaned = excludeUndefinedValues(section);
		
		
		cleaned.fields = cleaned.fields.map(field =>
		{
			// TODO: For some reason these aren't mutually exclusive
			if(field.text)
			{
				delete field.longText;
			}
			if(field.multiple_choice)
			{
				field.multiple_choice.options = field.multiple_choice.options.map(x =>
					({
						label: x.label,
						checked: false,
					})
				)
			}
			if(field.checkbox)
			{
				field.checkbox.options = field.checkbox.options.map(x =>
					({
						label: x.label,
						checked: false,
					})
				)
			}
			if(field.pass_fail)
			{
				delete field.pass_fail.value;
			}
			if(field.yes_no)
			{
				delete field.yes_no.value;
			}
			if(field.date)
			{
				delete field.date.time;
				delete field.date.date;
			}
			if(field.reading)
			{
				delete field.reading.value;
			}
			if(field.replace)
			{
				delete field.replace.value;
			}
			
			return field;
		});
		
		
		console.log(cleaned);
		
		
		return cleaned;
	})
}



export const convertFormDataToWorkOrderTemplate =
(
	form_data: WOTFormData,
	claims: Claims,
)
: WorkOrderTemplateNew =>
{
	let template_data =
	{
		...cloneDeep(form_data),
		
		file_ids: [],
		
		status: WorkOrderStatus.ACTIVE,
		
		asset_id: form_data.asset._id || '',
		asset_name: form_data.asset.name || '',
		component_ids: form_data.equipment.map(x => x._id),
		
		collaborator_ids: form_data.collaborators.map(x => x._id),
		parts_needed: form_data.parts.map(x => (
			{
				_id: x._id,
				name: x.name,
				quantity: x.selected_count,
			})),
		tag_ids: form_data.tags.map(x => x._id),
		issue_ids: form_data.issues.map(x => x._id),
		
		creator: {
			_id: claims?.user_id,
			name: claims?.name,
			email: claims?.email,
		},
		
		created_at: DateTime.utc().toISO(),
		start_datetime: DateTime.utc().toISO(),
		
		work_order_ids: [],
		assigned_to_role_ids: form_data.roles?.map(x => x._id) || [],
	}
	
	
	delete template_data.collaborators;
	delete template_data.equipment;
	delete template_data.parts;
	delete template_data.tags;
	delete template_data.issues;
	delete template_data.files;
	
	
	// TODO: Don't delete once we're ready to switch
	delete template_data.custom_form;
	
	
	if(form_data.recurrence.recurrence_type !== RecurrenceType.SCHEDULE)
	{
		// delete data2.recurrence.daily;
		delete template_data.recurrence.weekly;
		delete template_data.recurrence.monthly;
		delete template_data.recurrence.yearly;
		delete template_data.recurrence.recurrence_schedule;
	}
	
	if(form_data.recurrence.recurrence_type !== RecurrenceType.INTERVAL)
	{
		delete template_data.recurrence.interval;
	}
	
	
	template_data.recurrence.effective_datetime = (form_data.recurrence.effective_datetime as DateTime)?.toISO();
	
	if(nextAutomationDatetime(form_data.recurrence))
	{
		template_data.recurrence.next_automation_datetime =
			nextAutomationDatetime(form_data.recurrence)?.toISO();
	}
	
	
	if(template_data.recurrence.weekly)
	{
		template_data.recurrence.weekly.weekday_numbers = template_data.recurrence.weekly.weekday_numbers.filter(x => x !== undefined);
	}
	
	
	template_data.sections = cleanSections(template_data.sections);
	
	
	
	console.log(template_data.sections);
	
	
	return excludeUndefinedValues(template_data) as WorkOrderTemplateNew;
}


